import { X } from 'lucide-react';
import { Button } from './button';

interface DetailPageHeaderProps {
  onClose: () => void;
  title?: string;
  rightContent?: React.ReactNode;
}

export function DetailPageHeader({ onClose, title, rightContent }: DetailPageHeaderProps) {
  return (
    <header className="sticky top-0 z-50 bg-[#F0F0F0] border-b border-border">
      <div className="container mx-auto px-4 h-14 md:h-16 flex items-center justify-between">
        <Button variant="ghost" size="icon" onClick={onClose} aria-label="Close">
          <X className="w-5 h-5" />
        </Button>
        {(title || rightContent) && (
          <div className="flex items-center gap-2">
            {title && (
              <span className="text-sm font-medium hidden sm:inline">{title}</span>
            )}
            {rightContent}
          </div>
        )}
      </div>
    </header>
  );
}
